export default {
  restricted: {
    title: "Accesso limitato",
    description: "Devi aver effettuato l'accesso per visualizzare questa pagina.",
    login: "Accedi"
  },
  denied: {
    title: "Accesso negato",
    description: "Non disponi dei permessi necessari per accedere a questa pagina.",
    back: "Torna alla Home"
  },
  expired: {
    title: "Sessione scaduta",
    description: "La tua sessione è scaduta. Effettua nuovamente l'accesso.",
    login: "Accedi di nuovo"
  },
  invitation: {
    title: "Invito richiesto",
    description: "Hai bisogno di un invito per accedere a questa risorsa.",
    contact: "Contatta l'amministratore per ottenere un invito."
  },
  subscriptionRequired: {
    title: "Abbonamento richiesto",
    description: "Questa funzionalità richiede un abbonamento attivo.",
    upgrade: "Aggiorna"
  }
};

